import {
  SanityProductFragment,
  SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'
import { SanityGeneralSettings } from '@data/sanity/queries/types/site'
import { getSanityImageUrl } from '@lib/image'
import { Locale } from '@lib/language'
import { getProductGalleryPhotos } from '@lib/product-images'
import { getPageUrl } from '@lib/routes'

/**
 * Gets absolute product URL.
 */
export const getAbsoluteProductUrl = (
  locale: Locale,
  settings: SanityGeneralSettings,
  product: SanityProductFragment,
  activeVariant: SanityProductVariantFragment,
) => {
  const domain = settings.siteURL.replace(/\/+$/g, '')
  const productUrl = getPageUrl(locale, 'product', product.slug.current, {
    variant: `${activeVariant.variantID}`,
  })

  return `${domain}${productUrl}`
}

/**
 * Gets image URL for product.
 */
export const getProductImageUrl = (
  product?: SanityProductFragment,
  activeVariant?: SanityProductVariantFragment,
) => {
  const galleryPhotos = product?.galleryPhotos
    ? getProductGalleryPhotos(product.galleryPhotos, activeVariant)
    : []
  const galleryImages = galleryPhotos.filter((photo) => {
    return photo._type === 'figure'
  })

  if (galleryImages.length === 0) {
    return
  }

  return getSanityImageUrl(galleryImages[0], {
    width: 800,
    fitMax: true,
    autoFormat: true,
  })
}
